<script setup lang="ts">
const isVisible = useState('menu')
</script>

<template>
  <Teleport to="body">
    <div
      class="bg-gradient-primary fixed left-0 top-0 z-10 h-screen w-full overflow-hidden bg-grey-dark transition-opacity ease-linear"
      :class="isVisible ? 'opacity-100' : 'invisible opacity-0'"
    />
  </Teleport>
</template>
